<template>
  <PageWrapper
    :isLoading="isLoading"
    hasFilters
    @submitFilters="getAllUserFamilies"
  >
    <template #title> لیست کاربران دارای مشترک </template>
    <template #filters>
      <CustomSelect
        class="filters-width w-24"
        v-model="getAllUserFamiliesFilters.isVerify"
        :value="getAllUserFamiliesFilters.isVerify"
        inputId="isVerifyPicker"
        inputLabel="وضعیت تایید"
        :customOptions="isVerifyOptions"
      ></CustomSelect>
      <UserPicker class="w-50" @getUser="setUserIdFilter"></UserPicker>
    </template>
    <CustomTable
      ref="sharedFamily"
      v-if="usersList"
      :pageNumber="getAllUserFamiliesFilters.pageNumber"
      :count="getAllUserFamiliesFilters.count"
      :totalCount="totalCount"
      :tableColumns="tableColumns"
      :tableItems="usersList"
      @changePage="changePage"
    >
      <template #index="data">
        {{
          Math.ceil(
            data.index +
              1 +
              (getAllUserFamiliesFilters.pageNumber - 1) *
                getAllUserFamiliesFilters.count
          )
        }}
      </template>
      <template #userName="data">
        <b-link :to="`/users/${data.item.userFamily.userId}`">
          {{ data.item.userFamily.userName }}
        </b-link>
      </template>
      <template #actions="data">
        <BButton
          variant="success"
          size="sm"
          @click="renderRowDetails(data.index)"
        >
          مشاهده جزئیات
        </BButton>
      </template>
      <template #cellDetails="data">
        <UserFamilyListSection
          :userFamilyList="data.item.userFamily.family"
          :selectedUserId="data.item.userFamily.userId"
          @refetch="getAllUserFamilies"
        ></UserFamilyListSection>
      </template>
    </CustomTable>
  </PageWrapper>
</template>

<script>
export default {
  mounted() {
    this.getAllUserFamilies();
  },
  data() {
    return {
      isLoading: false,
      usersList: null,
      totalCount: null,
      getAllUserFamiliesFilters: {
        pageNumber: 1,
        count: 10,
        isVerify: null,
        userId: null,
      },
      isVerifyOptions: [
        {
          value: null,
          text: "همه",
        },
        {
          value: true,
          text: "تایید شده ها",
        },
        {
          value: false,
          text: "تایید نشده ها",
        },
      ],
      tableColumns: [
        {
          key: "index",
          label: "ردیف",
        },
        {
          key: "userName",
          label: "نام کاربر",
        },
        {
          key: "actions",
          label: "عملیات",
        },
      ],
    };
  },
  methods: {
    setUserIdFilter(userId) {
      this.getAllUserFamiliesFilters.userId = userId;
    },
    changePage(pageNumber) {
      this.getAllUserFamiliesFilters.pageNumber = pageNumber;
      this.getAllUserFamilies();
    },
    renderRowDetails(index) {
      if (this.$refs.sharedFamily) {
        this.$refs.sharedFamily.showRowDetails(index);
      }
    },
    setIsVerify(isVerify) {
      this.getAllUserFamiliesFilters.isVerify = isVerify;
    },
    async getAllUserFamilies() {
      try {
        this.isLoading = true;
        let _this = this;
        let getUserFamiliesForAdmin = new GetUserFamiliesForAdmin(_this);
        getUserFamiliesForAdmin.setRequestParam(
          _this.getAllUserFamiliesFilters
        );
        await getUserFamiliesForAdmin.fetch((res) => {
          _this.usersList = res.data.data;
          _this.totalCount = res.data.totalCount;
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  components: {
    PageWrapper,
    CustomTable,
    BLink,
    BButton,
    UserFamilyListSection,
    CustomSelect,
    UserPicker,
  },
};
import PageWrapper from "@/views/components/Utils/PageWrapper.vue";
import CustomTable from "@/views/components/Utils/CustomTable.vue";
import CustomSelect from "@/views/components/Utils/CustomSelect.vue";
import UserFamilyListSection from "@/views/components/Shared/UserFamilyListSection.vue";
import UserPicker from "@/views/components/Users/UserPicker.vue";
import { GetUserFamiliesForAdmin } from "@/libs/Api/Users";
import { BLink, BButton } from "bootstrap-vue";
</script>
